import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoadingSpinner } from '../components/common/LoadingSpinner'
import { useAuth } from '../context/AuthContext'

export const CallbackPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, loading, error } = useAuth()

  useEffect(() => {
    if (loading) {
      return
    }

    if (user) {
      navigate('/dashboard', { replace: true })
      return
    }

    navigate('/login', { replace: true })
  }, [loading, navigate, user])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-slate-950 dark:to-slate-900">
      <div className="text-center">
        <LoadingSpinner
          size="lg"
          text={error ? 'Authentication completed, but profile setup failed.' : 'Completing authentication...'}
        />
      </div>
    </div>
  )
}
